import { useState } from "react";

import { fetchJSON } from "lib/fetch";
import { getConfig } from "site-config";

import { FLOW_TYPE } from "constants/order-types";
import type { TAPIResponse } from "models/new/types";
import { API_STATES } from "../../helpers";

type TSmartOrderSetOrderFlowParams = {
    orderId: string;
    flowType?: FLOW_TYPE;
};

export type TSmartOrderSetOrderFlowResponse = TAPIResponse<TSmartOrderSetOrderFlowParams, string> & {
    setOrderFlowType: (params: TSmartOrderSetOrderFlowParams) => Promise<void>;
};

export const useSetOrderFlowType = (): TSmartOrderSetOrderFlowResponse => {
    const { api } = getConfig();

    const setOrderFlowType = (params: TSmartOrderSetOrderFlowParams) => {
        APIStates.pending();

        return fetchJSON(`${api}/working/update/${params.orderId}`, {
            method: "POST",
            body: JSON.stringify({ order_flow_type: params.flowType || FLOW_TYPE.immediate }),
        })
            .then(APIStates.success)
            .catch(APIStates.error);
    };

    const [state, setState] = useState<any>({
        ...API_STATES.default,
        setOrderFlowType,
    });

    const APIStates = API_STATES.getStates(setState);

    return {
        ...state,
        setOrderFlowType,
    };
};
